/* Copyright 2021, Milkdown by Mirone. */
export const font = {
    typography: '',
    code: '',
};
export const size = {
    radius: '0',
    lineWidth: '1px',
};
export const mixin = {
    scrollbar: () => '',
    shadow: () => '',
    border: () => '',
};
export const slots = {
    icon: (id) => {
        const div = document.createElement('div');
        div.className = 'milkdown-icon';
        div.textContent = id;
        return div;
    },
};
//# sourceMappingURL=default-value.js.map